module.exports = __webpack_public_path__ + "static/media/icon-dashboard-inbound-referral.f7267e64.svg";